module.exports = __webpack_public_path__ + "static/tr1min-953a9c76ba5b28a5cdb68e73d09eb365.jpg";